<template>
  <div id="about">
    <div class="aboutcontrol">
      <div @click.stop="aboutclick" :class="{aboutcontrolactiv:childpath =='/about/about'}"><i class="el-icon-s-home"></i>关于我们</div>
      <div @click.stop="statementclick" :class="{aboutcontrolactiv:childpath=='/about/statement'}"><i class="el-icon-tickets"></i>版权声明</div>
      <div @click.stop="useruploadxyclick" :class="{aboutcontrolactiv:childpath=='/about/useruploadxy'}"><i class="el-icon-tickets"></i>上传协议</div>
      <div @click.stop="downloadclick" :class="{aboutcontrolactiv:childpath=='/about/download'}"><i class="el-icon-download"></i>插件下载</div>
      <div @click.stop="helpclick" :class="{aboutcontrolactiv:childpath=='/about/help'}"><i class="el-icon-s-opportunity"></i>使用帮助</div>
      <div @click.stop="questionclick" :class="{aboutcontrolactiv:childpath=='/about/question'}"><i class="el-icon-question"></i>常见问题</div>
    </div>
    <router-view/>
  </div>
</template>

<script>

export default {
  name:'about',
  data() {
    return {

    }
  },
  props:{
    
  },
  computed: {
    childpath(){
      let str = this.$route.path
      return str
    },
  },
  components:{
    
  },
  methods: {
    aboutclick(){
      this.$router.push('/about/about')
    },
    statementclick(){
      this.$router.push('/about/statement')
    },
    useruploadxyclick(){
      this.$router.push('/about/useruploadxy')
    },
    downloadclick(){
      this.$router.push('/about/download')
    },
    helpclick(){
      this.$router.push('/about/help')
    },
    questionclick(){
      this.$router.push('/about/question')
    }
  },
}
</script>

<style>
#about::-webkit-scrollbar{
    width: 4px;
    height: 4px;
}
#about::-webkit-scrollbar-track{
    border-radius: 1px;
}
#about::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: #414141;
}
#about{
  overflow: hidden;
  overflow-y: auto;
}
.aboutcontrol{
  width: 160PX;
  height: 100%;
  background-color: rgb(240, 240, 240);
  padding: 20px 0;
  position: fixed;
}
.aboutcontrol > div{
  margin: 10px 0;
  line-height: 38px;
  text-indent: 20px;
  color: rgb(110, 115, 121);
  font-size: 14px;
  cursor: pointer;
}
.aboutcontrolactiv{
  background-color:rgba(0,0,0,0.10);
}
.aboutcontrolactiv > i{
  color: rgb(14, 30, 49);
}
.aboutcontrol > div:hover{
  background-color:rgba(0,0,0,0.10);
}
</style>